// extracted by mini-css-extract-plugin
export default {"errorText":"LoginForm_errorText__uPLYg","submitBtn":"LoginForm_submitBtn__xbjXX"};